export type CatalogModuleFileFormat = "skp" | "glb";

export const CATALOG_MODULE_FILE_ACCEPT = ".skp,.glb,model/vnd.sketchup,model/gltf-binary";

export function catalogModuleFileFormat(fileName: string): CatalogModuleFileFormat | null {
  const normalized = fileName.trim().toLocaleLowerCase("en-US");
  if (normalized.endsWith(".skp")) return "skp";
  if (normalized.endsWith(".glb")) return "glb";
  return null;
}

export function catalogModuleImportEndpoint(format: CatalogModuleFileFormat): string {
  return format === "glb" ? "/catalog-items/import-glb" : "/catalog-items/import-skp";
}
